import {toString} from 'es-toolkit/compat'

import * as optionApi from '../../../services/api/option'
import {
  PossiblyMixedValue,
  factorToPercentageString,
  isMixedValue,
  percentageStringToFactor,
  toNumberValue,
  toPossiblyMixedValue,
  toStringValue,
} from '../../utils/form'

import {OptionWithLinkedProviderInfos, Provider} from '../../../types'

export type SingleFormData = {
  name: string
  type: string
  basePrice: string
  productionTimeFastOffset: string
  productionTimeSlowOffset: string
  factor: string
  formikGeneral?: unknown // Need type to be able to set general validation error.
}

export type MixedFormData = {
  name: PossiblyMixedValue<string>
  type: PossiblyMixedValue<string>
  basePrice: PossiblyMixedValue<string>
  productionTimeFastOffset: PossiblyMixedValue<string>
  productionTimeSlowOffset: PossiblyMixedValue<string>
  factor: PossiblyMixedValue<string>
  formikGeneral?: unknown // Need type to be able to set general validation error.
}

export const initialValues: SingleFormData = {
  name: '',
  type: '',
  basePrice: '',
  productionTimeFastOffset: '',
  productionTimeSlowOffset: '',
  factor: '',
}

// FormData Options to optionApi Options

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formDataTransforms: Record<string, (value: any) => any> = {
  name: name => name,
  type: type => type,
  basePrice: toNumberValue,
  productionTimeFastOffset: toNumberValue,
  productionTimeSlowOffset: toNumberValue,
  factor: percentageStringToFactor,
}

export const formDataToOptionRequest = (
  formData: SingleFormData,
  provider: Provider
): optionApi.OptionRequest => ({
  name: formDataTransforms.name(formData.name),
  type: formDataTransforms.type(formData.type),
  factor: formDataTransforms.factor(formData.factor),
  basePrice: formDataTransforms.basePrice(formData.basePrice),
  productionTimeFastOffset: formDataTransforms.productionTimeFastOffset(
    formData.productionTimeFastOffset
  ),
  productionTimeSlowOffset: formDataTransforms.productionTimeSlowOffset(
    formData.productionTimeSlowOffset
  ),
  productionTimeFastTotal: null,
  productionTimeSlowTotal: null,
  materialId: null,
  provider: provider.id,
})

export const formDataToPartialOptionRequest = (formData: Partial<SingleFormData>) => {
  const optionsRequest: Partial<optionApi.OptionRequest> = {}

  Object.keys(formData).forEach(key => {
    const value = formData[key as keyof SingleFormData]
    const optionRequestTransform = formDataTransforms[key]

    if (!isMixedValue(value) && optionRequestTransform) {
      optionsRequest[key as keyof optionApi.OptionRequest] = optionRequestTransform(value)
    }
  })

  return optionsRequest
}

// optionApi Options to FormData Options

export const optionsToFormData = (options: OptionWithLinkedProviderInfos[]): MixedFormData => ({
  name: toPossiblyMixedValue(
    options.map(pricing => pricing.name),
    toString
  ),
  type: toPossiblyMixedValue(
    options.map(pricing => pricing.type),
    toString
  ),
  factor: toPossiblyMixedValue(
    options.map(pricing => pricing.factor),
    factorToPercentageString
  ),
  basePrice: toPossiblyMixedValue(
    options.map(pricing => pricing.basePrice),
    toStringValue
  ),
  productionTimeFastOffset: toPossiblyMixedValue(
    options.map(pricing => pricing.productionTimeFastOffset),
    toStringValue
  ),
  productionTimeSlowOffset: toPossiblyMixedValue(
    options.map(pricing => pricing.productionTimeSlowOffset),
    toStringValue
  ),
})
